import queryString from 'query-string';
import React, { Component } from 'react';
import { authManager } from 'src/services/auth';

export class AuthByToken extends Component {
  componentWillMount() {
    const { token } = queryString.parse(location.search);
    if (token) {
      authManager.setToken(token);
    }
  }

  render() {
    const token = authManager.getToken();
    return <div>Token：{token}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/screens/auth/AuthByToken.tsx